module.exports = __webpack_public_path__ + "static/img/logo.76077dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/logo.png
// module id = TWqG
// module chunks = 4